var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-box",attrs:{"id":"home"}},[_c('el-image',{attrs:{"src":require('@/assets/images/slide.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }